module.exports = __webpack_public_path__ + "images/from-sin-city-d66b61089d9a57f6bc46e3980ab3930e.png";